import React from 'react';
import AiFirmSetting from './AiFirmSetting';
import TaxDeliverySettings from './TaxDeliverySettings';

export default function Settings() {
  return (
    <>
      <AiFirmSetting />
      <TaxDeliverySettings />
    </>
  );
}
